import { render, staticRenderFns } from "./projectModel.vue?vue&type=template&id=a075a424"
import script from "./projectModel.vue?vue&type=script&lang=js"
export * from "./projectModel.vue?vue&type=script&lang=js"
import style0 from "./projectModel.vue?vue&type=style&index=0&id=a075a424&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports